import axios from "axios";
import { APIS } from "../utils/api-factory";
const POST_HEADER = {
  // 'Accept': 'application/json',
  "Content-Type": "application/json",
};

export const SaveUpdateDocumentTempConfig = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
    .post(APIS.SAVE_UPDATE_DOCUMENT_TEMP_CONFIG,data, headerConfig)
    .then((res) => {
        callBack(res.data);
    })
    .catch((e) => {
        // error(e.res.data);
    });
};

export const getDocumentTempListByPageEntry = (pageNumber,size, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
    .get(APIS.GET_DOCUMENT_TEMPLIST_BY_PAGE_ENTRY + pageNumber + "&noOfEntry=" + size, headerConfig)
    .then((res) => {
        callBack(res.data);
    })
    .catch((e) => {
        // error(e.res.data);
    });
};

export const getDocumentTempCountByPageEntry = ( callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
    .get(APIS.GET_DOCUMENT_TEMPCOUNT_BY_PAGE_ENTRY , headerConfig)
    .then((res) => {
        callBack(res.data);
    })
    .catch((e) => {
        // error(e.res.data);
    });
};

export const DeleteDocumentTempId = (id, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
    .delete(APIS.DELETE_DOCUMENT_TEMP_BY_ID + id , headerConfig)
    .then((res) => {
        callBack(res.data);
    })
    .catch((e) => {
        // error(e.res.data);
    });
};

export const SaveUpdateDocumentConfig = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
    .post(APIS.SAVE_UPDATE_DOCUMENT_CONFIG,data, headerConfig)
    .then((res) => {
        callBack(res.data);
    })
    .catch((e) => {
        // error(e.res.data);
    });
};

export const getDocConfigByPageEntryLicenseNumberProduct = (pageNumber,size,product, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
    .get(APIS.GET_DOC_CONFIG_BY_PAGE_ENTRY_LICENSENUMBER_AND_PRODUCT + pageNumber + "&noOfEntry=" + size  + "&product=" + product , headerConfig)
    .then((res) => {
        callBack(res.data);
    })
    .catch((e) => {
        // error(e.res.data);
    });
};

export const getDocConfigCountByLicenseNumberProduct = (product, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
    .get(APIS.GET_DOC_CONFIG_COUNT_BY_LICENSENUMBER_AND_PRODUCT + product , headerConfig)
    .then((res) => {
        callBack(res.data);
    })
    .catch((e) => {
        // error(e.res.data);
    });
};

export const DeleteDocConfigById = (id, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
    .delete(APIS.DELETE_DOC_CONFIG_BY_ID + id , headerConfig)
    .then((res) => {
        callBack(res.data);
    })
    .catch((e) => {
        // error(e.res.data);
    });
};